const lessonApi = process.env.REACT_APP_API_LESSON;
const microcredentialsApi = process.env.REACT_APP_API_MICROCREDENTIALS;
const lmsLessonApi = `${process.env.REACT_APP_LMS_API}api/Lesson`;
const lmsResourcesApi = `${process.env.REACT_APP_LMS_API}api/BraineeResources`;
const lmsInitiatorApi = `${process.env.REACT_APP_LMS_API}api/LessonInitiator`;
const lmsAttendanceApi = `${process.env.REACT_APP_LMS_API}api/LessonAttendance`;

const buildLessonEndpoints = (apiRoot) => ({
   listAllStaff: `${apiRoot}/listAllStaff`,
   updateSharedTeachers: `${apiRoot}/updateSharedTeachers`,
   listEntityLessonRecs: `${apiRoot}/listEntityLessonRecs`,
   listEntitySharedLessonRecs: `${apiRoot}/listEntitySharedLessonRecs`,
   listEntityLessonRecsbyTime: `${apiRoot}/listEntityLessonRecsbyTime`,
   listLessonRecs: `${apiRoot}/listLessonRecs`,
   getTeacherResources: `${lmsResourcesApi}/getLessonStudent`,
   delete: `${apiRoot}/deleteLesson`,
   duplicate: `${apiRoot}/duplicateLesson`,
   assignInfo: `${apiRoot}/assigninfo`,
   getItem: `${apiRoot}/getLessonItem`,
   add: `${apiRoot}/addLesson`,
   updateProperty: `${apiRoot}/updateLessonProperty`,
   updateContent: `${apiRoot}/updateLessonContent`,
   updateIndividualStatus: `${apiRoot}/updateIndividualLessonStatus`,
   getIndividualStatus: `${apiRoot}/getIndividualLessonStatus`,
   getResourcesItem: `${lmsResourcesApi}/getLessonItem`,
   addInitiator: `${lmsInitiatorApi}/addInitiator`,
   postAttendance: `${lmsAttendanceApi}/postAttendance`,
   getAttendance: `${lmsAttendanceApi}/getattendance`,
});

export const LESSON_MODULE = {
   key: 'lesson',
   label: 'Lesson',
   pluralLabel: 'Lessons',
   createLabel: 'Create Lesson',
   hasBraineeResources: true,
   idPrefix: 'lesson',
   itemQueryParam: 'lessonid',
   newItemQueryParam: 'newlessonid',
   routes: {
      list: '/subject',
      create: '/lesson/createlesson',
      editInfo: '/lesson/editlesson',
      edit: '/subject/edit',
      view: '/subject/view',
      contentEditor: '/subject/edit/lesson',
      resources: '/brainee-resources',
   },
   endpoints: buildLessonEndpoints(lessonApi),
};

export const buildQueryUrl = (url, params = {}) => {
   const query = new URLSearchParams();

   Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
         query.append(key, value);
      }
   });

   const queryString = query.toString();
   return queryString ? `${url}?${queryString}` : url;
};
